<div class="flex-column full-height gap-16">
  <div class="flex-space-between">
    <p class="b1 font-weight-semibold">{{ 'UTILITIES.TOOL.PRODUCTS.MATCHING_PRODUCTS' | bmsTranslate }}</p>
    <button mat-button [disabled]="isLoading" (click)="selectProducts()">
      <mat-icon svgIcon="solid-add"></mat-icon>
      {{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: (TRANSLATION_KEY | bmsTranslate: {count: 2} | lowercase)} }}
    </button>
  </div>
  <vdw-crud-overview-data-page class="no-padding no-background" [config]="config" [canShowActions]="false"></vdw-crud-overview-data-page>
</div>
